import { render, staticRenderFns } from "./Lgx192601493331771392.vue?vue&type=template&id=63cf2f6a&"
import script from "./Lgx192601493331771392.vue?vue&type=script&lang=js&"
export * from "./Lgx192601493331771392.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports